export function addressRestrictionKeysOnly(event): boolean {
	const charCode = event.which ? event.which : event.keyCode;
	const charStr = String.fromCharCode(charCode);
	if (
		String.fromCharCode(charCode) === "-" || // hyphen
		charCode === 32 || // space
		String.fromCharCode(charCode) === "/" ||
		(charCode >= 97 && charCode <= 122) ||
		(charCode >= 65 && charCode <= 90) ||
		(charCode >= 48 && charCode <= 57) // numeric keys
	) {
		return true;
	}
	return false;
}
